import ApplicationLogDto from './ApplicationLogDto'

/**
 * @member {ApplicationLogDto[]} list
 */
export default class ApplicationLogListDto {
  list

  /**
   * @param {ApplicationLogDto[]} list
   */
  constructor(list) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    list = Array.isArray(list) ? list.map(dto => new ApplicationLogDto(dto)) : []

    Object.defineProperty(this, 'list', Object.assign({ value: list }, properties))
    Object.freeze(this)
  }
}
